<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path fill-rule="evenodd" d="M19.862 6.062c-.451-.988-1.806-.92-2.543-.101l-6.652 7.384v13.322h12.41c1.363 0 2.589-.79 3.095-1.994l3.046-7.247c.076-.181.116-.375.116-.57v-2.242c0-1.05-.896-1.903-2-1.903h-8l.835-3.787a4.526 4.526 0 00-.307-2.862zm-7.195 7.987l5.605-6.222a2.7 2.7 0 01-.06.706l-.836 3.787a1.835 1.835 0 00.405 1.59c.38.446.95.704 1.553.704h8v2.171l-3.02 7.182a1.335 1.335 0 01-1.237.797h-10.41V14.05zm-6 1.285v9.333h-2v-9.333h2zm2 10.333a1 1 0 01-1 1h-4a1 1 0 01-1-1V14.334a1 1 0 011-1h4a1 1 0 011 1v11.333z" clip-rule="evenodd"/></svg>
</template>

<script>
export default {
  name: 'symbolsLikeOutline'
}
</script>
